import { combineReducers } from 'redux';

const byId = (state = {}, action) => {
  const {
    fieldName,
    isFocused,
    value,
    originalValue,
    isValid,
    errorMsgId,
    formId,
  } = action;
  const field = state[fieldName];
  switch (action.type) {
    case 'INITIALIZE_FIELDS':
      const { fields } = action;
      return {
        ...state,
        ...fields,
      };
    case 'FIELD_FOCUS_CHANGE':
      if (!state[fieldName]) return state;
      const newFocusState = {};
      Object.keys(state).map(key => {
        newFocusState[key] = {
          ...state[key],
          isFocused: key === fieldName ? isFocused : false,
        };
      });
      return newFocusState;
    case 'ENABLE_FORM_RECONCILIATION_MODE':
      const newReconState = {};
      Object.keys(state).map(key => {
        const field = state[key];
        newReconState[key] = {
          ...field,
          showError: true,
        };
      });
      return newReconState;
    case 'FIELD_VALUE_CHANGE':
      if (!field || typeof value === 'undefined') return state;
      return {
        ...state,
        [fieldName]: {
          ...field,
          value,
          isValid,
          errorMsgId,
        },
      };
    case 'UPDATE_FIELD_ORIGINAL_VALUE':
      return {
        ...state,
        [fieldName]: {
          ...field,
          originalValue,
        },
      };
    case 'UPDATE_FIELD_VALIDITY':
      const updatedField = state[fieldName];
      if (!updatedField || typeof errorMsgId === 'undefined') return state;
      return {
        ...state,
        [fieldName]: {
          ...updatedField,
          isValid,
          errorMsgId,
          // For the Stripe field, we want to pass through the specific error,
          // but we’re going to rely on their localization for now.
          errorMsg: action.text ? action.text : undefined,
        },
      };
    case 'REMOVE_FIELDS':
      const removedState = { ...state };
      Object.keys(removedState).map(id => {
        const field = removedState[id];
        if (field.formId === formId) delete removedState[id];
      });
      return removedState;
    default:
      return state;
  }
};

const groupedByFormId = (state = {}, action) => {
  const { formId, fields } = action;
  switch (action.type) {
    case 'INITIALIZE_FIELDS':
      return {
        ...state,
        [formId]: Object.keys(fields),
      };
    case 'REMOVE_FIELDS':
      const removedState = { ...state };
      delete removedState[formId];
      return removedState;
    default:
      return state;
  }
};

const fields = combineReducers({
  byId,
  groupedByFormId,
});

export default fields;

export const getFieldsByFormId = (state, formId) => {
  const fieldNames = state.groupedByFormId[formId];
  if (!fieldNames) return null;
  const fields = {};
  fieldNames.map(name =>
    state.byId[name] ? (fields[name] = state.byId[name]) : null
  );
  return Object.keys(fields).length ? fields : null;
};
export const getField = (state, id) => {
  if (!id || !Object.keys(state.byId).includes(id)) return null;
  return state.byId[id];
};
